import React, { useEffect, useCallback } from 'react'
import { MenuItem } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import { useSelector } from 'react-redux'
import { IReducer } from '../../interface'
import countriesJSON from 'country-region-data/data.json'

export default function USStates({
  americaStateSelected,
  setAmericaStateSelected,
  EEUUStates
}: {
  EEUUStates: Set<string>
  americaStateSelected: string
  setAmericaStateSelected: Function
}) {
  const userInfo: any = useSelector((state: IReducer) => state.accountReducer.userInfo)

  const handleChange = useCallback(
    (newState: string) => {
      setAmericaStateSelected(newState)
    },
    [setAmericaStateSelected]
  )

  useEffect(() => {
    if (EEUUStates.size > 1 && userInfo && userInfo.BillToAccountObj.Country.toLowerCase() === 'us') {
      const userState = userInfo.BillToAccountObj.State
      handleChange(userState)
    }
  }, [userInfo, handleChange, EEUUStates.size])

  const US = countriesJSON.find((item) => item.countryName === 'United States')
  if (US) {
    const USRegions = US.regions
      .filter((region) => EEUUStates.has(region.shortCode ? region.shortCode : ''))
      .map((region) => (
        <MenuItem value={region.shortCode} key={region.shortCode} data-cy='state-dropdownItem'>
          {region.name}
        </MenuItem>
      ))
    return (
      <Select
        sx={{ textAlign: 'left', mb: 2 }}
        size='small'
        value={americaStateSelected}
        fullWidth
        onChange={(event: SelectChangeEvent) => handleChange(event.target.value)}
        data-cy='state-dropdown'
      >
        <MenuItem value={'none'} disabled>
          <FormattedMessage id='sales.selectState' />
        </MenuItem>
        {USRegions}
      </Select>
    )
  }
  return null
}
